import { useState } from "react";

const CommonSearch = (props: any) => {
  const [searchInput, setSearchInput] = useState("");

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toLowerCase();
    setSearchInput(value);

    const filtered = props?.allEmployeeData?.filter((item) =>
      item?.Name?.toLowerCase().includes(value) ||
      item?.Email?.toLowerCase().includes(value) ||
      // item?.address.toLowerCase().includes(value) ||
      item?.Phone?.toLowerCase().includes(value)
    );
    props.setFilteredData(filtered);
  };
  return (
    <div>
      <label style={{ color: "#000" }}>Search</label>
      <input
        type="text"
        className="form-control form-control-sm me-2"
        placeholder="Search by Name, Address, or Mobile"
        style={{
          backgroundColor: "#b4b4b447",
          padding: "0.2rem 0.85rem",
          marginTop: "5px",
        }}
        value={searchInput}
        onChange={handleSearch}
      />
    </div>
  );
};

export default CommonSearch;
